import { render } from "./EventDetails.vue?vue&type=template&id=40df7b8e&scoped=true"
import script from "./EventDetails.vue?vue&type=script&lang=js"
export * from "./EventDetails.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-40df7b8e"

export default script